import React, { useState, useEffect } from 'react';
import FeaturedResourceCard from './FeaturedResourceCard';
import TripleLine from './TripleLine';
import { Resource } from '../common/types';
import { getResources } from '../utils/api';
import LogoLoading from './animations/LogoLoading';

interface ResourceHeaderProps {
    title: string;
    subtitle: string;
    imageLink: string;
    backgroundHeaderImage: string;
    onResourceClick: (resource: Resource) => void;
}

const ResourceHeader: React.FC<ResourceHeaderProps> = ({ title, subtitle, imageLink, backgroundHeaderImage, onResourceClick }) => {
    const [resources, setResources] = useState<Resource[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getResources();
                setResources(response.data.sort((a: Resource, b: Resource) => Number(a.id) - Number(b.id)).slice(0, 2));
                setIsLoading(false);
            } catch (err) {
                setError(err as Error);
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <div
            className="relative overflow-hidden flex flex-col items-center justify-center h-[600px] md:h-[900px] bg-cover bg-center font-jarkarta"
            style={{ backgroundImage: `url(${backgroundHeaderImage})` }}
        >
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent via-black/60 to-custom-black"></div>
            <div className="relative z-10 text-center p-4 md:p-8 lg:p-12">
                <h2 className="text-white text-4xl md:text-5xl lg:text-6xl font-medium mb-4">{title}</h2>
                <p className="text-white text-lg md:text-xl lg:text-2xl max-w-4xl mx-auto">{subtitle}</p>
                <div className='flex justify-center my-8'>
                    <TripleLine />
                </div>
            </div>
            <div className='md:absolute bottom-8 z-10'>
                <div className='w-full mx-auto flex justify-center'>
                </div>
                <div className="md:flex flex-col md:flex-row justify-center hidden">
                    {isLoading ? (
                        <LogoLoading />
                    ) : (
                        resources.map((resource) => (
                            <div key={resource.id} onClick={() => onResourceClick(resource)}>
                                <FeaturedResourceCard key={resource.id} {...resource} />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default ResourceHeader;
